// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sX-z","smallCardRow":"tX-z","largeCardRow":"uX-z","productSearchRow":"vX-z","curatedRow":"wX-z"};